var map = {
	"./FocusRoot": 332,
	"./FocusRoot.tsx": 332,
	"./maps/CapabilitiesMap": 210,
	"./maps/CapabilitiesMap.tsx": 210,
	"./maps/MainMap": 4789,
	"./maps/MainMap.tsx": 4789,
	"./maps/UniqueValueMap": 4490,
	"./maps/UniqueValueMap.tsx": 4490,
	"./pages/CustomerUnmetNeeds": 4809,
	"./pages/CustomerUnmetNeeds.tsx": 4809,
	"./pages/FoundationInPurpose": 1561,
	"./pages/FoundationInPurpose.tsx": 1561,
	"./pages/OperatingArena": 6059,
	"./pages/OperatingArena.tsx": 6059,
	"./pages/SafeguardsAgainstImitation": 2199,
	"./pages/SafeguardsAgainstImitation.tsx": 2199,
	"./pages/UnifiedBusinessModel": 5674,
	"./pages/UnifiedBusinessModel.tsx": 5674,
	"components/focuses/FocusRoot": 332,
	"components/focuses/FocusRoot.tsx": 332,
	"components/focuses/maps/CapabilitiesMap": 210,
	"components/focuses/maps/CapabilitiesMap.tsx": 210,
	"components/focuses/maps/MainMap": 4789,
	"components/focuses/maps/MainMap.tsx": 4789,
	"components/focuses/maps/UniqueValueMap": 4490,
	"components/focuses/maps/UniqueValueMap.tsx": 4490,
	"components/focuses/pages/CustomerUnmetNeeds": 4809,
	"components/focuses/pages/CustomerUnmetNeeds.tsx": 4809,
	"components/focuses/pages/FoundationInPurpose": 1561,
	"components/focuses/pages/FoundationInPurpose.tsx": 1561,
	"components/focuses/pages/OperatingArena": 6059,
	"components/focuses/pages/OperatingArena.tsx": 6059,
	"components/focuses/pages/SafeguardsAgainstImitation": 2199,
	"components/focuses/pages/SafeguardsAgainstImitation.tsx": 2199,
	"components/focuses/pages/UnifiedBusinessModel": 5674,
	"components/focuses/pages/UnifiedBusinessModel.tsx": 5674
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4802;
module.exports = webpackAsyncContext;